import React, { type CSSProperties } from 'react';

import { getRegionByCode } from '@luxuryescapes/lib-regions';

interface Props {
  region: string;
  style?: CSSProperties;
}

function Flag({ region, style }: Props) {
  const regionName = getRegionByCode(region)?.name;
  const icon = region === 'world' ? 'flag-icon-un' : 'flag-icon-' + region.toLowerCase();

  return <span title={regionName} className={'flag-icon ' + icon} style={style} />;
}

export default Flag;
